import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		// Controller is connected to the share button element
		this.element.addEventListener('click', this.handleShare.bind(this));
	}

	disconnect() {
		this.element.removeEventListener('click', this.handleShare.bind(this));
	}

	handleShare(e) {
		e.preventDefault();

		const url = this.element.dataset.url;
		const title = this.element.dataset.title;

		// Try Web Share API first (mobile friendly)
		if (navigator.share) {
			navigator.share({
				title: title,
				url: url
			}).catch(err => {
				// User cancelled or error occurred
				console.log('Share cancelled or failed:', err);
			});
		} else {
			// Fallback: copy to clipboard
			navigator.clipboard.writeText(url).then(() => {
				// Show temporary success message
				const originalHTML = this.element.innerHTML;
				this.element.innerHTML = '<span style="font-size: 12px; color: #198754;">✓ Copié!</span>';

				setTimeout(() => {
					this.element.innerHTML = originalHTML;
				}, 2000);
			}).catch(err => {
				console.error('Could not copy text:', err);
			});
		}
	}
}
